import { Sparkle } from "lucide-react";

const WORDS = ["Peindre", "Déguster", "Émailler", "Créer", "Partager", "Ralentir"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#E5DCD3] bg-[#201815] py-5">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display italic text-2xl sm:text-3xl text-[#FBF8F3]">{w}</span>
                <Sparkle size={16} className="text-[#C85A32]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
